import { compareVersions } from './compareVersions';
export const isIncompatibilityModules = (installedModules, COMPATIBLE_VERSION, groupLabel = 'Installed Modules') => {
    console.groupCollapsed(groupLabel);
    let incompatibility = false;
    installedModules.forEach(({ node }) => {
        if (!node)
            return;
        const { name, version } = node;
        console.info(`[${name}] ${version}`);
        const compatibility = COMPATIBLE_VERSION[name];
        if (compatibility) {
            const minLimit = compareVersions(version, compatibility.min);
            const maxLimit = compareVersions(version, compatibility.max);
            if (minLimit < 0 || maxLimit >= 0) {
                console.warn(`Version '${name}' is not in the compatibility range '${compatibility.min}' - '${compatibility.max}'.`);
                incompatibility = true;
            }
        }
    });
    console.groupEnd();
    return incompatibility;
};
//# sourceMappingURL=isIncompatibilityModules.js.map